export default "__VITE_ASSET__CplH_6xq__"